module.exports = __webpack_public_path__ + "static/media/IMG-6.7c2247b1.jpg";